import { useSearchParams, useNavigate, Link } from "react-router-dom";

export default function PaymentCancel() {
    const [params] = useSearchParams();
    const nav = useNavigate();
    const bookingId = params.get("booking_id");

    return (
        <div className="min-h-screen bg-[#FAFAF8] flex items-center justify-center p-6">
            <div className="max-w-md w-full bg-white border border-[#EDE6D6] p-8 text-center shadow-sm"
                 data-testid="payment-cancel-card">
                <div className="text-5xl text-[#B2912A] mb-4">ⓘ</div>
                <h1 className="font-serif text-3xl text-[#180A21] mb-2">Payment cancelled</h1>
                <p className="text-sm text-[#555] mb-6">
                    You didn't complete the checkout. Your booking is still saved — you can retry payment any time.
                </p>
                {bookingId ? (
                    <button
                        data-testid="pay-cancel-back-booking"
                        onClick={() => nav(`/customer/bookings/${bookingId}`)}
                        className="lx-btn-gold px-6 py-3 text-sm"
                    >
                        Back to booking
                    </button>
                ) : (
                    <Link to="/customer/bookings" className="lx-btn-gold px-6 py-3 text-sm inline-block">
                        Go to my bookings
                    </Link>
                )}
            </div>
        </div>
    );
}
